import { ManagementComponent } from '../management.component';
import { Component, OnInit, OnDestroy, Inject, ViewChild, NgZone } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';
import { SignalRService, MassEmailProgressUpdate, MassEmailCompleteMessage } from 'src/app/services/signalr.service';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-partnersdata',
  templateUrl: './partnersdata.component.html',
  styleUrls: ['./partnersdata.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class PartnersdataComponent implements OnInit, OnDestroy {

  // SignalR subscriptions for cleanup
  private signalRSubscriptions: Subscription[] = [];
  private signalRConnectionId: string | null = null;

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute, private signalRService: SignalRService, private ngZone: NgZone) {

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

      // Debounce search.
      this.configSearchTermUpdate.pipe(
        debounceTime(500),
        distinctUntilChanged())
        .subscribe(value => {
  
          if(value?.length >= 1){
            this.ConfigurationTerm = value;
            this.GetImportConfigurations();
          }
        });

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
       this.Filter.SearchTerm = value;

       if(this.Filter.SearchTerm.length == 0){
        this.Partners = [];
        this.PartnersCount = 0;
       }
       else{
        this.GetPartnersFiltered();
       }
      });

    // Debounce search for Blocked Partners tab.
    this.blockedSearchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.BlockedFilter.SearchTerm = value;

        if(this.BlockedFilter.SearchTerm?.length == 0){
          this.BlockedPartners = [];
          this.BlockedPartnersCount = 0;
        }
        else{
          this.GetBlockedPartnersFiltered();
        }
      });

        // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value);
        }
      });

          // Debounce search.
     this.brandSearchTermUpdateForYearSettings.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFilteredForYearSettings(value);
        }
      });

             // Debounce search.
     this.brandSearchTermUpdateForNewYearSettings.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFilteredForNewYearSettings(value);
        }
      });

        // Debounce search.
     this.countrySearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.SpareCountries = JSON.parse(JSON.stringify(this.Countries));
          this.SpareCountries = this.SpareCountries.filter(country =>
            country.Name.toLowerCase().startsWith(value.toLowerCase())
          );
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  brandSearchTermUpdate = new Subject<string>();
  brandSearchTermUpdateForYearSettings = new Subject<string>();
  brandSearchTermUpdateForNewYearSettings = new Subject<string>();

  configSearchTermUpdate = new Subject<string>();
  groupSearchTermUpdate = new Subject<string>();
  countrySearchTermUpdate = new Subject<string>();

  SpareCountries:any[];
  SearchTerm:string;
  Partners:[];
  PartnersCount:number;
  Partner: {[k: string]: any} = {};
  Filter: {[k: string]: any} = {};
  ShowFilter:boolean;

  // Tab selection: 1 = Partners Management, 2 = Blocked Partners
  selectedPartnersTab: number = 1;

  // Blocked Partners Tab Data
  BlockedPartners: any[] = [];
  BlockedPartnersCount: number = 0;
  BlockedFilter: {[k: string]: any} = {};
  ShowBlockedFilter: boolean = false;
  blockedActiveFilters: {[k: string]: any} = [];
  blockedSearchTermUpdate = new Subject<string>();

  // Blocked Filter dropdown states
  showBlockedFilterCompanyDropdown: boolean = false;
  showBlockedFilterCountryDropdown: boolean = false;

  showFilterAccountTypeDropdown: boolean = false;
  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  Countries:any[];
  Companies:any[];
  Banks:any[];
  AuxBanks:any[];
  CurrentBank:any;
  CurrentShippingAddress:any;
  ProfitSettingsPercentageImpacts:any[];
  Currencies:any[];
  DecimalPrecisions:any[];

  ShowBillingInfo:boolean;
  ShowShippingInfo:boolean;
  ShowAgentsInfo:boolean;
  ShowProfitSettings:boolean;
  ShowProcessingSettings:boolean;
  ShowB2BRestrictions:boolean;
  ShowContractualConditions:boolean;
  ShowAcceptedEmailDomains:boolean;

  // Accepted Email Domains
  AcceptedDomains:any[] = [];
  NewAcceptedEmailDomain:string = '';
  DeletingAcceptedDomain:any;
  ShowDeleteAcceptedDomainQuestion:boolean = false;
  InvalidAcceptedDomainFormat:boolean = false;

  // Contractual Conditions
  ContractualConditions:{[k: string]: any} = {};
  PaymentTerms:any[];
  PartnerAccountTypes:any[];
  loadingContractExport:boolean = false;
  showBuyPaymentTermsDropdown:boolean = false;
  showSellPaymentTermsDropdown:boolean = false;
  showContractualAccountTypeDropdown:boolean = false;

  // B2B Master Data for Contractual Conditions - using parent.CartMasterData
  // PaymentTypes, ConsolidationTypes, DeliveryPreferences, ShippingCompanies, ShippingResponsabilities, ShippingServiceTypes

  // Dropdown state variables for new contractual conditions fields
  showContractualShippingCompanyDropdown:boolean = false;
  showContractualShippingResponsabilityDropdown:boolean = false;
  showContractualPaymentTypeDropdown:boolean = false;
  showContractualShippingServiceTypeDropdown:boolean = false;
  showContractualConsolidationTypeDropdown:boolean = false;
  showContractualDeliveryPreferenceDropdown:boolean = false;

  // Dropdown state variables for modern custom dropdowns
  showBillingCountryDropdown: boolean = false;
  showBankDropdown: boolean = false;
  showShippingAddressDropdown: boolean = false;
  showShippingCountryDropdown: boolean = false;
  showAgentsDropdown: boolean = false;
  showAgentShippingDropdown: boolean = false;
  showDepartmentDropdown: boolean = false;
  showCompanyDropdown: boolean = false;
  showCurrencyDropdown: boolean = false;
  showDecimalDropdown: boolean = false;
  showPartnerCompanyDropdown: boolean = false;
  showB2BCategoryDropdown: boolean = false;
  showInsuranceDictatorDropdown: boolean = false;
  showInsuranceIllustratorDropdown: boolean = false;

  // Shipping popup dropdowns
  showShippingResponsabilityDropdown: boolean = false;
  showShippingCompanyDropdown: boolean = false;
  showShippingServiceDropdown: boolean = false;

  // Profit settings dropdowns
  showConfigurationDropdown: boolean = false;
  showGroupDropdown: boolean = false;
  showBrandDropdown: boolean = false;
  showPercentageImpactDropdown: boolean = false;

  // Restriction dropdowns
  showRestrictionTypeDropdown: boolean = false;
  showRestrictionConfigDropdown: boolean = false;
  showRestrictionBrandDropdown: boolean = false;
  showRestrictionCountryDropdown: boolean = false;

  // Year settings dropdowns
  showNewYearBrandDropdown: boolean = false;
  showYearBrandDropdown: boolean = false;

  // Filter dropdowns
  showFilterCompanyDropdown: boolean = false;
  showFilterCountryDropdown: boolean = false;

  // Partner Carrier Accounts
  PartnerCarrierAccounts: any[] = [];
  CurrentPartnerAccount: any = {};
  ShowPartnerAccountPopUp: boolean = false;
  loadingPartnerAccounts: boolean = false;
  PartnerAccountDirections: any[] = [];

  // Public Link Popup
  ShowPublicLinkPopup: boolean = false;
  PublicLinkUrl: string = '';

  // Partner Account dropdowns
  showPartnerAccountShippingCompanyDropdown: boolean = false;
  showPartnerAccountDirectionDropdown: boolean = false;
  showPartnerAccountServiceTypeDropdown: boolean = false;

  BrandFilter: {[k: string]: any} = {};
  CountryFilter: {[k: string]: any} = {};
  Brands:any[];
  Brand:any;
  BrandSearchTerm:string;
  Country:any;

  ImportConfigurations:any[];
  ConfigurationTerm:string;

  RestrictionTypes:any[];
  InsurancePolicyDictators:any[];
  InsurancePolicyIllustrators:any[];

  GroupTerm:string;

  ngOnInit(): void {
    this.InitializeFilter();
    this.InitializeBlockedFilter();
    this.GetMasterData();
    this.GetAllCompanies();
    this.GetPartnersFiltered();
    this.InitializeBrandFilter();
    this.InitializeCountryFilter();

    this.ShowBillingInfo = false;
    this.ShowShippingInfo = true;
    this.ShowAgentsInfo = false;
    this.ShowProfitSettings = false;
    this.ShowProcessingSettings = false;
    this.ShowB2BRestrictions = false;
    this.ShowContractualConditions = false;
    this.ShowAcceptedEmailDomains = false;

    // Initialize Insurance Policy Dictators
    this.InsurancePolicyDictators = [
      { ID: 1, Name: 'INSURANCE_DICTATOR_PARTNER_POLICY' },
      { ID: 2, Name: 'INSURANCE_DICTATOR_SHIPPING_RESPONSIBILITY' }
    ];

    // Initialize Insurance Policy Illustrators
    this.InsurancePolicyIllustrators = [
      { ID: 1, Name: 'INSURANCE_ILLUSTRATOR_SEPARATE_POSITION' },
      { ID: 2, Name: 'INSURANCE_ILLUSTRATOR_SUMMED_IN_SHIPPING' }
    ];

    // Check for partnerID query parameter and auto-open partner edit form
    this.route.queryParams.subscribe(params => {
      const partnerID = params['partnerID'];
      if (partnerID) {
        this.loadPartnerAndOpenEditForm(partnerID);
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up SignalR subscriptions
    this.cleanupSignalRSubscriptions();
  }

  private cleanupSignalRSubscriptions(): void {
    this.signalRSubscriptions.forEach(sub => sub.unsubscribe());
    this.signalRSubscriptions = [];
  }

  loadPartnerAndOpenEditForm(partnerID: string): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: partnerID
    };

    this.parent.loading = true;
    this.service.GetPartner(request).subscribe(response => {
      if (response["Status"] == 1 && response["Partner"]) {
        this.InitializeNewPartnerForm(response["Partner"]);
      } else {
        this.parent.openSnackBar(response["Message"] || "Partner not found", "OK", "alert-info-snackbar");
      }
      this.parent.loading = false;
    });
  }

  InitializeCountryFilter(){
    this.CountryFilter = {};
    this.CountryFilter.SearchTerm = "";
    this.CountryFilter.Pager = {};
    this.CountryFilter.Pager.PageIndex = 1;
    this.CountryFilter.Pager.PageSize = 50;
    this.CountryFilter.Pager.TotalCount = 0;
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 50;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  GetBrandsFiltered(searchTerm:string, page = 1){
    
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
    
         if(this.Brands.length == 1){
          this.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.Restriction.RestrictedBrand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.BrandSearchTerm = this.Restriction?.RestrictedBrand?.Name;

          this.Brands = [];
          this.BrandFilter.SearchTerm = "";
         }
        }
       });
  }

   ClearSearchBrand(){
    this.BrandFilter.SearchTerm = "";
    this.BrandSearchTerm = "";
    this.Brand = null;
    this.Brands = [];
   }
  
  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;
    
    this.Filter.Country = {};
    this.Filter.Country = null;

    this.Filter.AccountType = null;
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.ShowFilter = false;
      // this.GetIndustryProductsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Company"){
      this.Filter.Company = null;
    }
    else if(filterType == "ProductBoxStatus"){
      this.Filter.ProductBoxStatus = null;
    }
    else if(filterType == "ProductConditionStatus"){
      this.Filter.ProductConditionStatus = null;
    }
    else if(filterType == "ProductManufacturingStatus"){
      this.Filter.ProductManufacturingStatus = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "ProductVersionStatus"){
      this.Filter.ProductVersionStatus = null;
    }
    else if(filterType == "Brand"){
      this.Filter.Brand = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "AccountType"){
      this.Filter.AccountType = null;
    }

    // this.GetIndustryProductsFiltered();
  }

  ClearAccountTypeFilter(){
    this.Filter.AccountType = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != 'AccountType');
    this.showFilterAccountTypeDropdown = false;
  }

  GetMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Countries = response["Countries"];
        this.Banks = response["Banks"];
        this.AuxBanks = JSON.parse(JSON.stringify(this.Banks));
        this.ProfitSettingsPercentageImpacts = response["ProfitSettingsPercentageImpacts"];
        this.RestrictionTypes = response["RestrictionTypes"];
        this.GetPartnersMasterData();
      }
   
      this.parent.loading = false;
    });
  }

  B2BPartnerCategories:any[];
  FileExportTypes:any[] = [];
  showEmailAttachmentTypeDropdown:boolean = false;

  // B2B User Settings - for Partner-centric B2B User management
  B2BConnectedUser: any = null;              // The user connected to the current partner
  B2BConnectedAgent: any = null;             // The agent connected to the B2B user
  B2BAppAccess: any = null;                  // B2B App access status (App ID: 3)
  UserHasB2BAppAccess: boolean = false;      // Whether the user has B2B app access enabled
  Agents: any[] = [];                        // List of company agents for dropdown
  ShowB2BAgentSelectContainer: boolean = false;    // Controls Agent selector popup visibility
  ShowB2BAgentDeallocation: boolean = false;       // Controls Agent deallocation confirmation popup
  ShowB2BGrantURLsAccess: boolean = false;         // Controls URL access grant confirmation popup
  loadingB2BUserSettings: boolean = false;         // Loading state for B2B user settings section
  showAgentsDropdownB2B: boolean = false;          // Dropdown state for B2B agent selection

  GetPartnersMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetPartnersMasterData(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.B2BPartnerCategories = response["B2BPartnerCategories"];
        this.PaymentTerms = response["PaymentTerms"];
        this.PartnerAccountTypes = response["PartnerAccountTypes"];
        this.FileExportTypes = response["FileExportTypes"];
      }

      this.parent.loading = false;
    });
  }



  GetAllCompanies(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetAllCompanies(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Companies = response["Companies"];
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.Filter.SearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID,
      AccountTypeID:this.Filter.AccountType?.ID
    };

    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }

      this.parent.loading = false;
    });
  }

  // ========================================
  // Blocked Partners Tab Methods
  // ========================================

  InitializeBlockedFilter(){
    this.BlockedFilter = {};
    this.BlockedFilter.SearchTerm = "";
    this.BlockedFilter.Country = null;
    this.BlockedFilter.Company = null;
    this.BlockedFilter.Pager = {};
    this.BlockedFilter.Pager.PageIndex = 1;
    this.BlockedFilter.Pager.PageSize = 50;
    this.BlockedFilter.Pager.TotalCount = 0;
    this.BlockedFilter.Pager.Pages = 1;
  }

  GetBlockedPartnersFiltered(){
    var request = {
      SearchTerm: this.BlockedFilter.SearchTerm,
      CountryID: this.BlockedFilter.Country?.ID,
      PageIndex: this.BlockedFilter.Pager.PageIndex,
      PageSize: this.BlockedFilter.Pager?.PageSize,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: this.BlockedFilter.Company?.ID
    };

    this.parent.loading = true;

    this.service.GetBlockedPartnersFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.BlockedPartners = response["Partners"];
        this.BlockedFilter.Pager.TotalCount = response["Count"];
        this.BlockedFilter.Pager.Pages = Math.ceil(response["Count"] / this.BlockedFilter.Pager.PageSize) || 1;
      }

      this.parent.loading = false;
    });
  }

  AddBlockedActiveFilter(filterName: string, filterType: string){
    var filter = {
      ID: Math.random().toString(36).substring(2, 9),
      Name: filterName,
      Type: filterType
    };

    this.blockedActiveFilters = this.blockedActiveFilters.filter((x: any) => x.Name != filterName && x.Type != filterType);
    this.blockedActiveFilters.push(filter);
  }

  RemoveBlockedActiveFilter(ID: string, filterType: string){
    this.blockedActiveFilters = this.blockedActiveFilters.filter((x: any) => x.ID != ID);

    if(filterType == "Company"){
      this.BlockedFilter.Company = null;
    }
    else if(filterType == "Country"){
      this.BlockedFilter.Country = null;
    }

    this.GetBlockedPartnersFiltered();
  }

  /**
   * Handles tab selection. Resets filters to initial values and fetches data.
   * @param tabIndex 1 = Partners Management, 2 = Blocked Partners
   */
  onSelectPartnersTab(tabIndex: number){
    // Don't do anything if already on this tab
    if(this.selectedPartnersTab === tabIndex){
      return;
    }

    this.selectedPartnersTab = tabIndex;

    if(tabIndex === 1){
      // Reset Partners Management tab
      this.InitializeFilter();
      this.activeFilters = [];
      this.ShowFilter = false;
      this.GetPartnersFiltered();
    }
    else if(tabIndex === 2){
      // Reset Blocked Partners tab
      this.InitializeBlockedFilter();
      this.blockedActiveFilters = [];
      this.ShowBlockedFilter = false;
      this.GetBlockedPartnersFiltered();
    }
  }

  // ========================================
  // View Overdue Invoices Modal
  // ========================================
  showOverdueInvoicesModal: boolean = false;
  OverdueInvoices: any[] = [];
  loadingOverdueInvoices: boolean = false;
  currentOverduePartner: any = null;

  /**
   * Opens the overdue invoices modal for a blocked partner.
   * Calls GetAggregatedOverdueInvoices to fetch the invoices that caused the blocking.
   */
  ViewOverdueInvoices(partner: any){
    if(!partner) return;

    this.currentOverduePartner = partner;
    this.loadingOverdueInvoices = true;
    this.showOverdueInvoicesModal = true;
    this.OverdueInvoices = [];

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      B2BPartner: partner
    };

    this.B2BService.GetAggregatedOverdueInvoices(request).subscribe(response => {
      if(response["Status"] == 1){
        this.OverdueInvoices = response["Invoices"];
      }
      else {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      this.loadingOverdueInvoices = false;
    });
  }

  CloseOverdueInvoicesModal(){
    this.showOverdueInvoicesModal = false;
    this.OverdueInvoices = [];
    this.currentOverduePartner = null;
  }

  /**
   * Calculates days late from payment due date to today.
   */
  GetDaysLate(paymentDueDate: any): number {
    if(!paymentDueDate) return 0;
    const dueDate = moment(paymentDueDate);
    const today = moment();
    return today.diff(dueDate, 'days');
  }

  ShowAddNewPartnerForm:boolean;

  InitializeNewPartnerForm(p:any){
    this.ShowAddNewPartnerForm = true;
    this.Partner = JSON.parse(JSON.stringify(p));
    this.CurrentBank = JSON.parse(JSON.stringify(this.Partner.Bank));
    this.Banks = JSON.parse(JSON.stringify(this.AuxBanks));
    this.CurrentShippingAddress = {};
    this.GetPartnerShippingAddresses(this.Partner.ID);
    this.GetPartnerCarrierAccounts(this.Partner.ID);

    // Reset agent state to prevent cross-partner contamination
    this.PartnerAgent = null;
    this.PartnerAgents = [];

    this.ShowBillingInfo = true;
    this.ShowShippingInfo = false;
    this.ShowAgentsInfo = false;
    this.ShowProfitSettings = false;
    this.ShowProcessingSettings = false;
    this.ShowB2BRestrictions = false;
    this.ShowContractualConditions = false;
    this.ShowAcceptedEmailDomains = false;
  }

  SwitchPartnerBank(b:any){
    if(b.ID == this.CurrentBank?.ID){
      this.Banks.forEach(bank => {
        if(bank.ID == this.CurrentBank?.ID){
          bank.BankAccount = this.CurrentBank?.BankAccount;
        }
      });
    }
  }

  GetPartnerEUData(partner:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.VAT,
      CountryCode:partner.BillingAddress.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){
        this.Partner.BillingAddress.Country = response["Country"];
        this.Partner.VAT = response["VAT"];
        this.Partner.EUVATVerified = response["EUVATVerified"];
        this.Partner.Name = response["Name"];
        this.Partner.BillingAddress.AddressLine = response["Address"];
      }
   
      this.parent.loading = false;
    });
  }

  GenerateInitialShippingAddress(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.Partner
    };

    this.parent.loading = true;
    this.service.GenerateInitialShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner = response["Partner"];

        var addressesLength = JSON.parse(JSON.stringify(this.Partner.ShippingAddresses?.length));

        if(addressesLength != null && addressesLength > 0){
          this.CurrentShippingAddress = this.Partner.ShippingAddresses[addressesLength - 1];
        }
      }
   
      this.parent.loading = false;
    });
  }

  AddUpdateShippingAddress(address:any, PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:address,
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.AddUpdateShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentShippingAddress = response["ShippingAddress"];

        if(this.CurrentShippingAddress.ID == 0){
          this.Partner.ShippingAddresses.push(this.CurrentShippingAddress);
        }
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerShippingAddresses(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.GetPartnerShippingAddresses(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ShippingAddresses = response["ShippingAddresses"];
        this.CurrentShippingAddress = this.Partner.ShippingAddresses[0];
        this.GetShippingMasterData();
      }
   
      this.parent.loading = false;
    });
  }

  PartnerAgent:any;
  ShippingAddresses:any[];
  Departments:any[];
  ShowPartnerAddressDeleteMessage:boolean;
  PartnerAgents:any[];

  ShowPartnerAgentDeleteMessage:boolean;

  InitializePartnerAgent(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.InitializePartnerAgent(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgent = response["PartnerAgent"];
        this.ShippingAddresses = response["ShippingAddresses"];
        this.Departments = response["Departments"];
      }
   
      this.parent.loading = false;
    });
  }

  DeletePartnerShippingAddress(shippingAddress:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:shippingAddress
    };

    this.parent.loading = true;
    this.service.DeletePartnerShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ShippingAddresses = this.Partner.ShippingAddresses.filter(x => x.ID != shippingAddress.ID);
        this.CurrentShippingAddress = null;
      }
   
      this.parent.loading = false;
    });
  }

  AddUpdatePartnerAgent(){
    // Safety: ensure the agent's PartnerID matches the currently open partner
    if(this.PartnerAgent != null && this.Partner?.ID?.length > 0){
      this.PartnerAgent.PartnerID = this.Partner.ID;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerAgent:this.PartnerAgent
    };

    this.parent.loading = true;
    this.service.AddUpdatePartnerAgent(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgent = response["PartnerAgent"];

        // Only add to list if not already present (avoid duplicates on update)
        var existingIndex = this.PartnerAgents.findIndex(x => x.ID == this.PartnerAgent.ID);
        if(existingIndex >= 0){
          this.PartnerAgents[existingIndex] = this.PartnerAgent;
        } else {
          this.PartnerAgents.push(this.PartnerAgent);
        }

        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.parent.loading = false;
    });
  }

  GetPartnerAgents(PartnerID:string, IsForDispatchEmail:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.GetPartnerAgents(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgents = response["PartnerAgents"];
        this.ShippingAddresses = this.Partner.ShippingAddresses;

        if(IsForDispatchEmail == true){
          this.PartnerAgents.forEach(element => {
            element.IsSelected = false;
          });
          this.ShowShipmentRequestPopup = true;
        }

        // Load default phases for each agent
        this.loadAllAgentsDefaultPhases();
      }

      this.parent.loading = false;
    });
  }

  loadAllAgentsDefaultPhases(): void {
    if (!this.PartnerAgents || this.PartnerAgents.length === 0) return;
    this.PartnerAgents.forEach((agent: any) => {
      if (agent.ID > 0) {
        const req = {
          User: this.parent.User,
          Language: this.parent.getLanguage(),
          AgentID: agent.ID
        };
        this.service.GetPartnerAgentDefaultPhases(req).subscribe((res: any) => {
          if (res.Status === 1) {
            agent.OrderPhases = res.Phases || [];
          }
        });
      }
    });
  }

  DeletePartnerAgent(AgentID:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AgentID:AgentID
    };

    this.parent.loading = true;
    this.service.DeletePartnerAgent(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgents = this.PartnerAgents.filter(x => x.ID != AgentID);
        this.PartnerAgent = null;
      }
   
      this.parent.loading = false;
    });
  }

  AddNewPartner(partner:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:partner,
    };

    this.parent.loading = true;
    this.service.AddNewPartner(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.parent.loading = false;
      }
      else if(response["Status"] == 1){
        if(response["DuplicateDetected"]){
          this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || ""), "OK", "alert-danger-snackbar");
          // Close the add form, refresh list, and load the REAL existing partner from DB
          this.ShowAddNewPartnerForm = false;
          this.GetPartnersFiltered();
          this.loadPartnerAndOpenEditForm(response["ID"]);
        } else {
          this.GetPartnersFiltered();
          this.loadPartnerAndOpenEditForm(response["ID"]);
          this.parent.loading = false;
        }
      }
    });
  }

  UpdatePartner(partner:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:partner,
    };

    this.parent.loading = true;
    this.service.UpdatePartner(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner = response["Partner"];
        this.ShowAddNewPartnerForm = false;
        this.GetPartnersFiltered();
      }

      this.parent.loading = false;
    });
  }

  InitializeNewPartner(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;
    this.service.InitializeNewPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner = response["Partner"];
        this.Partner.Company = this.parent.Company;
        this.ShowAddNewPartnerForm = true;

        // Reset agent state to prevent cross-partner contamination
        this.PartnerAgent = null;
        this.PartnerAgents = [];

        this.ShowBillingInfo = true;
        this.ShowShippingInfo = false;
        this.ShowAgentsInfo = false;
        this.ShowProfitSettings = false;
        this.ShowProcessingSettings = false;
        this.ShowB2BRestrictions = false;
        this.ShowContractualConditions = false;
        this.ShowAcceptedEmailDomains = false;
      }
   
      this.parent.loading = false;
    });
  }

  ShowNewProfitSettings:boolean = false;
  ProfitSettings:{[k: string]: any} = {};
  ShowDeleteProfitMessage:boolean = false;

  OpenNewProfitSettings(){1
    this.GetBrandsFiltered("", 1);
  
    this.ProfitSettings = {
      ID:0,
      PartnerID:this.Partner?.ID,
      PartnerName:this.Partner?.Name,
      DiscountGroup:null,
      ImportConfiguration:null,
      Brand:this.Brand,
      Percentage:null,
      PercentageImpact:this.ProfitSettingsPercentageImpacts[0],
      ExtraAddedValue:null,
      ExtraAddedPercentageValue:null,
    };
  
    this.ConfigurationTerm = null;
    this.BrandSearchTerm = this.Brand?.Name;
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
    this.parent.loading = true;
    
    this.service.CheckUserProfitRights(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowNewProfitSettings = true;
      }
    
      this.parent.loading = false;
     });
  }

  GetImportConfigurations(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:this.ConfigurationTerm
    };
    
    this.parent.loading = true;
    
    this.managementService.GetImportConfigurations(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ImportConfigurations = response["ImportConfigurations"];
      }
    
      this.parent.loading = false;
     });
    }
  
  InitializeImportConfigurations(){
      if(this.ImportConfigurations == null || this.ImportConfigurations.length == 0){
        this.GetImportConfigurations();
      }
  }

  SelectConfiguration(c:any){
      this.ProfitSettings.ImportConfiguration = c;
      this.ConfigurationTerm = c.Name;
      this.GetImportConfigurationDetails(c);
  }

  GetImportConfigurationDetails(c:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:c.ID
    };

    this.parent.loading = true;
    this.managementService.GetImportConfigurationDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ProfitSettings.ImportConfiguration = response["Configuration"];
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerProfitSettings(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.Partner.ID
    };
    
    this.parent.loading = true;
    
    this.service.GetPartnerProfitSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.PartnerProfitSettings = response["PartnerProfitSettings"];
        this.Partner.PartnerProfitSettings = this.Partner.PartnerProfitSettings.filter(x => x.PartnerID == this.Partner.ID);
      }
    
      this.parent.loading = false;
     });
  }

  AddUpdatePartnerProfitSettings(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProfitSettings:this.ProfitSettings,
    };
    
    this.parent.loading = true;
    
    this.service.AddUpdatePartnerProfitSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var ps = response["ProfitSettings"];
        
        const index = this.Partner.PartnerProfitSettings.findIndex(x => x.ID === ps.ID);

        if (index !== -1) {
          this.Partner.PartnerProfitSettings[index] = ps;
        }
        else{
          this.Partner.PartnerProfitSettings.push(ps);
        }
      }
    
      this.parent.loading = false;
     });
  }

  EditProfitSettings(ps:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
    this.parent.loading = true;
    
    this.service.CheckUserProfitRights(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.OpenProfitSettings(ps);
      }
    
      this.parent.loading = false;
     });
  }

  OpenProfitSettings(ps:any){
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.SearchTerm = "";
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
         this.ProfitSettings = JSON.parse(JSON.stringify(ps));
         this.ConfigurationTerm = this.ProfitSettings.ImportConfiguration?.Name;
         this.BrandSearchTerm = this.ProfitSettings.Brand?.Name;
         this.GetImportConfigurationDetails(this.ProfitSettings.ImportConfiguration);
        }
       });

    this.ShowNewProfitSettings = true;
  }

  DeleteProfitSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProfitSettings:this.ProfitSettings
    };
    
    this.parent.loading = true;
    
    this.service.DeleteProfitSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.Partner.PartnerProfitSettings = this.Partner.PartnerProfitSettings.filter(x => x.ID != this.ProfitSettings.ID);
        this.ProfitSettings = null;
        this.ProfitSettings = {};
      }
    
      this.ShowDeleteProfitMessage = false;
      this.ShowNewProfitSettings = false;
      this.parent.loading = false;
     });
  }

  CopyProfitSettingsUI(ps:any){
    this.CopyProfitSettings(ps);
  }

  CopyProfitSettings(ps:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
    this.parent.loading = true;
    
    this.service.CheckUserProfitRights(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.OpenProfitSettingsCopy(ps);
      }
    
      this.parent.loading = false;
     });
  }
    
  OpenProfitSettingsCopy(ps:any){
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.SearchTerm = "";
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };
  
      this.managementService.GetBrandsFiltered(request).subscribe(response => {
  
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
         this.ProfitSettings = JSON.parse(JSON.stringify(ps));
         this.ConfigurationTerm = this.ProfitSettings.ImportConfiguration?.Name;
         this.BrandSearchTerm = this.ProfitSettings.Brand?.Name;
  
         if(this.ProfitSettings.ImportConfiguration != null){
          this.GetImportConfigurationDetails(this.ProfitSettings.ImportConfiguration);
         }
  
         this.ProfitSettings.ID = 0;
         this.ProfitSettings.IsCopy = true;
        }
       });
  
    this.ShowNewProfitSettings = true;
  }

  GetPartnerProcessingSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.Partner,
    };

    this.parent.loading = true;

    this.service.GetPartnerProcessingSettings(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ProcessingSettings = response["ProcessingSettings"];
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];

        // Match EmailAttachmentType to master data list by ID for dropdown binding
        if(this.Partner.ProcessingSettings?.EmailAttachmentType?.ID != null && this.FileExportTypes?.length > 0){
          var matched = this.FileExportTypes.find((x:any) => x.ID === this.Partner.ProcessingSettings.EmailAttachmentType.ID);
          if(matched) this.Partner.ProcessingSettings.EmailAttachmentType = matched;
        }
      }

      // Also fetch grouping settings and insurance policy
      this.GetPartnerProcessingSettingsGrouping();
      this.GetPartnerInsurancePolicy();
     });
  }

  GetPartnerProcessingSettingsGrouping(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.Partner.ID,
    };

    this.service.GetPartnerProcessingSettingsGrouping(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.GroupingSettings = response["GroupingSettings"];
      }

      this.parent.loading = false;
     });
  }

  AddUpdatePartnerProcessingSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProcessingSettings:this.Partner.ProcessingSettings,
    };

    this.parent.loading = true;

    this.service.AddUpdatePartnerProcessingSettings(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ProcessingSettings = response["ProcessingSettings"];
      }

      this.parent.loading = false;
     });
  }

  AddUpdatePartnerProcessingSettingsGrouping(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      GroupingSettings:this.Partner.GroupingSettings,
    };

    this.parent.loading = true;

    this.service.AddUpdatePartnerProcessingSettingsGrouping(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.GroupingSettings = response["GroupingSettings"];
      }

      this.parent.loading = false;
     });
  }

  GetPartnerInsurancePolicy(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.Partner.ID,
    };

    this.service.GetPartnerInsurancePolicy(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.InsurancePolicy = response["InsurancePolicy"];
      }

      this.parent.loading = false;
     });
  }

  AddUpdatePartnerInsurancePolicy(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InsurancePolicy:this.Partner.InsurancePolicy,
    };

    this.parent.loading = true;

    this.service.AddUpdatePartnerInsurancePolicy(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.InsurancePolicy = response["InsurancePolicy"];
      }

      this.parent.loading = false;
     });
  }

  SaveAllProcessingSettings(){
    // Save processing settings, grouping settings, and insurance policy
    var request1 = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProcessingSettings:this.Partner.ProcessingSettings,
    };

    var request2 = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      GroupingSettings:this.Partner.GroupingSettings,
    };

    var request3 = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InsurancePolicy:this.Partner.InsurancePolicy,
    };

    this.parent.loading = true;

    // Save processing settings first
    this.service.AddUpdatePartnerProcessingSettings(request1).subscribe(response1 => {
      if(response1["Status"] != 1){
        this.parent.openSnackBar(response1["Message"], "OK", "alert-info-snackbar");
        this.parent.loading = false;
        return;
      }

      this.Partner.ProcessingSettings = response1["ProcessingSettings"];

      // Then save grouping settings
      this.service.AddUpdatePartnerProcessingSettingsGrouping(request2).subscribe(response2 => {
        if(response2["Status"] != 1){
          this.parent.openSnackBar(response2["Message"], "OK", "alert-info-snackbar");
          this.parent.loading = false;
          return;
        }

        this.Partner.GroupingSettings = response2["GroupingSettings"];

        // Then save insurance policy
        this.service.AddUpdatePartnerInsurancePolicy(request3).subscribe(response3 => {
          if(response3["Status"] != 1){
            this.parent.openSnackBar(response3["Message"], "OK", "alert-info-snackbar");
          }
          else if(response3["Status"] == 1){
            this.Partner.InsurancePolicy = response3["InsurancePolicy"];
            this.parent.openSnackBar("Settings saved successfully", "OK", "alert-info-snackbar");
          }

          this.parent.loading = false;
        });
      });
    });
  }

  ShowNewRestrictionSettings:boolean = false;
  Restriction: {[k: string]: any} = {};

  InitializeNewRestriction(partner:any, res:any = null){

    if(res == null){
      this.Restriction = null;
      this.Restriction = {};
  
      this.Restriction.PartnerID = partner.ID;
      this.Restriction.Type = this.RestrictionTypes[0];
  
      this.Restriction.RestrictedConfiguration = {};
      this.Restriction.RestrictedConfiguration = null;
  
      this.Restriction.RestrictedBrand = {};
      this.Restriction.RestrictedBrand = null;
  
      this.Restriction.RestrictedCountry = {};
      this.Restriction.RestrictedCountry = null;
    }
    else if(res?.ID > 0){
      this.Restriction = JSON.parse(JSON.stringify(res));
    }
   

    this.ShowNewRestrictionSettings = true;
  }

  InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered(this.BrandSearchTerm, 1);
    }
  }

  InitializeCountries(){
      this.SpareCountries = JSON.parse(JSON.stringify(this.Countries));
  }

  ClearSearchCountry(){
    this.CountryFilter.SearchTerm = "";
    this.CountrySearchTerm = "";

    if(this.Restriction?.RestrictedCountry != null){
      this.Restriction.RestrictedCountry = null;
    }

    this.SpareCountries = JSON.parse(JSON.stringify(this.Countries));
  }

  SelectRestrictionConfiguration(c:any){
    this.Restriction.RestrictedConfiguration = c;
    this.ConfigurationTerm = c.Name;
}

ClearRestrictionConfiguration(){
  this.Restriction.RestrictedConfiguration = null;
  this.ConfigurationTerm = "";
}

SelectRestrictionType(t:any){
  if(t.ID == -1){
    this.Restriction.RestrictedBrand = {};
    this.Restriction.RestrictedBrand = null;
    this.BrandSearchTerm = null;

    this.Restriction.RestrictedCountry = {};
    this.Restriction.RestrictedCountry = null;
    this.CountrySearchTerm = null;
  }
  else if(t.ID == 1){
    this.Restriction.RestrictedConfiguration = {};
    this.Restriction.RestrictedConfiguration = null;
    this.ConfigurationTerm = null;

    this.Restriction.RestrictedCountry = {};
    this.Restriction.RestrictedCountry = null;
    this.CountrySearchTerm = null;
  }
  else if(t.ID == 2){
    this.Restriction.RestrictedConfiguration = {};
    this.Restriction.RestrictedConfiguration = null;
    this.ConfigurationTerm = null;

    this.Restriction.RestrictedBrand = {};
    this.Restriction.RestrictedBrand = null;
    this.BrandSearchTerm = null;
  }
}

CountrySearchTerm:string;

SelectRestrictionCountry(c:any){
  this.Restriction.RestrictedCountry = c;
  this.CountrySearchTerm = c.Name;
}

AddUpdatePartnerB2BRestriction(){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Restriction:this.Restriction,
  };
  
  this.parent.loading = true;
  
  this.service.AddUpdatePartnerB2BRestriction(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var res = response["Restriction"];
      const index = this.Partner.B2BRestrictions?.findIndex(x => x.ID === res.ID);

      if (index !== -1) {
        this.Partner.B2BRestrictions[index] = res;
      }
      else{
        this.Partner.B2BRestrictions.push(res);
      }
    }
  
    this.ShowNewRestrictionSettings = false;
    this.parent.loading = false;
   });
}

GetPartnerB2BRestictions(){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:this.Partner.ID
  };
  
  this.parent.loading = true;
  
  this.service.GetPartnerB2BRestictions(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Partner.B2BRestrictions = JSON.parse(JSON.stringify(response["Restrictions"]));
    }
  
    this.parent.loading = false;
   });
}

DeletingRestriction:any;
ShowDeleteRestrictionQuestion:boolean = false;

PrepareRestrictionDelete(res:any){
  this.DeletingRestriction = JSON.parse(JSON.stringify(res));
  this.ShowDeleteRestrictionQuestion = true;
}

CurrentYearSettings:any;
ShowDeleteYearSettingsQuestion:boolean = false;

PrepareYearSettingsDelete(s:any){
  this.CurrentYearSettings = JSON.parse(JSON.stringify(s));
  this.ShowDeleteYearSettingsQuestion = true;
}

DeletePartnerB2BRestriction(res:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:res.ID
  };
  
  this.parent.loading = true;
  
  this.service.DeletePartnerB2BRestriction(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Partner.B2BRestrictions = this.Partner.B2BRestrictions.filter(x => x.ID != res.ID);
    }
  
    this.parent.loading = false;
   });
}


GetPartnerB2BSettings(){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:this.Partner.ID
  };
  
  this.parent.loading = true;
  
  this.service.GetPartnerB2BSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Partner.B2BSettings = JSON.parse(JSON.stringify(response["B2BSettings"]));
      this.GetPartnersB2BHistoryYearSettings();
    }
  
    this.parent.loading = false;
   });
}

AddUpdatePartnerB2BSettings(){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    B2BSettings:this.Partner.B2BSettings
  };
  
  this.parent.loading = true;
  
  this.service.AddUpdatePartnerB2BSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Partner.B2BSettings = JSON.parse(JSON.stringify(response["B2BSettings"]));
    }
  
    this.parent.loading = false;
   });
}

// ========================================================================================
// B2B User Settings Methods - Partner-centric B2B User management
// ========================================================================================

/**
 * Retrieves the B2B User connected to the current Partner.
 * This is the reverse lookup of GetB2BUserConnectedPartner (User → Partner).
 * Called when opening B2B Settings popup to show connected user info.
 *
 * Flow:
 * 1. Call GetPartnerB2BUserConnection to get the UserID
 * 2. Call GetUser to get the full user details
 */
GetB2BPartnerConnectedUser() {
  if (!this.Partner?.ID) return;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    PartnerID: this.Partner.ID
  };

  this.loadingB2BUserSettings = true;

  this.B2BService.GetPartnerB2BUserConnection(request).subscribe(response => {
    if (response["Status"] == 1 && response["UserID"]) {
      // We got the UserID, now fetch the full user details
      this.FetchB2BConnectedUserDetails(response["UserID"]);
    } else {
      // No user connected to this partner
      this.B2BConnectedUser = null;
      this.B2BConnectedAgent = null;
      this.UserHasB2BAppAccess = false;
      this.loadingB2BUserSettings = false;
    }
  });
}

/**
 * Fetches full user details by UserID.
 * Called after GetPartnerB2BUserConnection returns a UserID.
 */
FetchB2BConnectedUserDetails(userID: string) {
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    id: userID
  };

  this.service.GetUser(request).subscribe(response => {
    if (response["Status"] == 1) {
      this.B2BConnectedUser = response["User"];

      if (this.B2BConnectedUser?.Id) {
        // Fetch additional B2B user data
        this.GetB2BUserConnectedAgent();
        this.ProofB2BAppAccess();
      }
    } else {
      // User fetch failed
      this.B2BConnectedUser = null;
      this.B2BConnectedAgent = null;
      this.UserHasB2BAppAccess = false;
    }

    this.loadingB2BUserSettings = false;
  });
}

/**
 * Gets the Agent connected to the B2B User.
 */
GetB2BUserConnectedAgent() {
  if (!this.B2BConnectedUser?.Id) return;

  var request = {
    User: { Id: this.B2BConnectedUser.Id },
    Language: this.parent.getLanguage()
  };

  this.loadingB2BUserSettings = true;

  this.B2BService.GetB2BUserConnectedAgent(request).subscribe(response => {
    if (response["Status"] == 1) {
      this.B2BConnectedAgent = response["Agent"];
    } else {
      this.B2BConnectedAgent = null;
    }

    this.loadingB2BUserSettings = false;
  });
}

/**
 * Gets the Company Agents for the Agent selection dropdown.
 */
GetCompanyAgentsForB2B() {
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    CompanyID: this.parent.Company.ID
  };

  this.service.GetCompanyAgents(request).subscribe(response => {
    if (response["Status"] == 1) {
      this.Agents = response["Agents"];
    }
  });
}

/**
 * Opens the Agent selection popup.
 */
OpenB2BAgentSelectContainer() {
  this.ShowB2BAgentSelectContainer = true;
  this.GetCompanyAgentsForB2B();
}

/**
 * Selects a B2B Agent from the dropdown.
 */
SelectB2BAgent(agent: any) {
  this.B2BConnectedAgent = agent;
}

/**
 * Connects/Updates the B2B User to an Agent.
 */
AddUpdateB2BUserAgentConnection() {
  if (!this.B2BConnectedUser?.Id || !this.B2BConnectedAgent?.ID) return;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    AgentID: this.B2BConnectedAgent.ID,
    UserID: this.B2BConnectedUser.Id
  };

  this.loadingB2BUserSettings = true;

  this.B2BService.AddUpdateB2BUserAgentConnection(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else {
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.ShowB2BAgentSelectContainer = false;
    }

    this.loadingB2BUserSettings = false;
  });
}

/**
 * Prepares the Agent deallocation confirmation popup.
 */
PrepareB2BAgentDeallocation() {
  this.ShowB2BAgentDeallocation = true;
}

/**
 * Deallocates the Agent from the B2B User.
 */
DeallocateB2BUserAgentConnection() {
  if (!this.B2BConnectedUser?.Id || !this.B2BConnectedAgent?.ID) return;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    AgentID: this.B2BConnectedAgent.ID,
    UserID: this.B2BConnectedUser.Id
  };

  this.loadingB2BUserSettings = true;

  this.B2BService.DeallocateB2BUserAgentConnection(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else {
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.B2BConnectedAgent = null;
    }

    this.ShowB2BAgentDeallocation = false;
    this.loadingB2BUserSettings = false;
  });
}

/**
 * Fetches AppAccess from the dedicated endpoint and checks if the connected B2B User has B2B App Access (App ID: 3).
 */
ProofB2BAppAccess() {
  if (!this.B2BConnectedUser?.Id) {
    this.UserHasB2BAppAccess = false;
    this.B2BAppAccess = null;
    return;
  }

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    UserID: this.B2BConnectedUser.Id
  };

  this.service.GetUserAppAccess(request).subscribe(response => {
    this.UserHasB2BAppAccess = false;
    this.B2BAppAccess = null;

    if (response["Status"] == 1 && response["UserAppAccess"]) {
      // Store on the user object for consistency
      this.B2BConnectedUser.AppAccess = response["UserAppAccess"];

      response["UserAppAccess"].forEach((access: any) => {
        // B2B App ID is 3
        if (access.Application?.ID === 3 || access.Application?.Name === "B2B") {
          this.B2BAppAccess = access;
          if (access.Application?.Access === true || access.Access === true) {
            this.UserHasB2BAppAccess = true;
          }
        }
      });
    }
  });
}

/**
 * Toggles B2B App Access for the connected user.
 * When enabled, automatically grants all B2B URLs access.
 */
ToggleB2BAppAccess(enable: boolean) {
  if (!this.B2BConnectedUser?.Id) return;

  var AppAccess = {
    ID: this.B2BAppAccess?.ID || 0,
    Application: {
      ID: 3,
      Name: "B2B",
      Access: enable
    },
    UserID: this.B2BConnectedUser.Id,
    Access: enable
  };

  var request = {
    Language: this.parent.getLanguage(),
    User: this.parent.User,
    AppAccess: AppAccess
  };

  this.loadingB2BUserSettings = true;

  this.service.AddUpdateUserAppAccess(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else {
      this.UserHasB2BAppAccess = enable;

      // Use the response AppAccess which contains the correct ID from the database
      // This prevents duplicate rows by ensuring we have the correct ID for future updates
      if (response["AppAccess"]) {
        this.B2BAppAccess = response["AppAccess"];
        this.B2BAppAccess.Access = enable; // Ensure Access reflects the current state
      } else {
        this.B2BAppAccess = AppAccess;
      }

      // Show success message for app access toggle
      const accessAction = enable ? 'ENABLED' : 'DISABLED';
      const appAccessId = this.B2BAppAccess?.ID || 'N/A';
      console.log(`[B2B App Access] ${accessAction} - AppAccess ID: ${appAccessId}, UserID: ${this.B2BConnectedUser?.Id}`);
      this.parent.openSnackBar(`B2B App Access ${accessAction} (ID: ${appAccessId})`, "OK", "light-info-snackbar");

      // Show confirmation popup to grant or revoke all B2B URLs
      this.ShowB2BGrantURLsAccess = true;
    }

    this.loadingB2BUserSettings = false;
  });
}

/**
 * Grants or revokes all B2B URLs access for the connected user.
 * Uses B2BAppAccess.Access to determine grant (true) or revoke (false).
 */
GrantB2BUserAppUrlsAccess() {
  if (!this.B2BConnectedUser?.Id) return;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    UserID: this.B2BConnectedUser.Id,
    Application: {
      ID: 3,
      Name: "B2B",
      Access: this.B2BAppAccess?.Access === true
    }
  };

  this.ShowB2BGrantURLsAccess = false;
  this.loadingB2BUserSettings = true;

  const urlAction = request.Application.Access ? 'GRANTED' : 'REVOKED';
  console.log(`[B2B URLs Access] Requesting ${urlAction} for all B2B URLs - UserID: ${request.UserID}`);

  this.service.GrantUserAppUrlsAccess(request).subscribe(response => {
    if (response["Status"] != 1) {
      console.log(`[B2B URLs Access] FAILED: ${response["Message"]}`);
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else {
      console.log(`[B2B URLs Access] SUCCESS: All B2B URLs ${urlAction}`);
      this.parent.openSnackBar(`All B2B URLs ${urlAction} successfully!`, "OK", "light-info-snackbar");
    }

    this.loadingB2BUserSettings = false;
  });
}

/**
 * Cancels the URL access grant confirmation.
 */
CancelB2BGrantURLsAccess() {
  this.ShowB2BGrantURLsAccess = false;
}

// ========================================================================================
// End of B2B User Settings Methods
// ========================================================================================

GetPartnerContractualConditions(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:this.Partner.ID
  };

  this.parent.loading = true;

  this.service.GetPartnerContractualConditions(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ContractualConditions = JSON.parse(JSON.stringify(response["ContractualConditions"]));
    }

    this.parent.loading = false;
   });
}

AddUpdatePartnerContractualConditions(){

  this.ContractualConditions.PartnerID = this.Partner.ID;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ContractualConditions:this.ContractualConditions
  };

  this.parent.loading = true;

  this.service.AddUpdatePartnerContractualConditions(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ContractualConditions = JSON.parse(JSON.stringify(response["ContractualConditions"]));
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }

    this.parent.loading = false;
   });
}

selectContractualShippingResponsability(sr: any) {
  this.ContractualConditions.ShippingResponsability = sr;
  this.showContractualShippingResponsabilityDropdown = false;

  // Auto-reset UsePartnerCarrierAccount to false when non-EXW (ID != 0) is selected
  if (sr?.ID !== 0) {
    this.ContractualConditions.UsePartnerCarrierAccount = false;
  }
}

ExportPartnerContract(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:this.Partner.ID
  };

  this.loadingContractExport = true;

  this.service.ExportPartnerContract(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.loadingContractExport = false;
   });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

NewYearSettings: {[k: string]: any} = {};
CurrentYearSetting:any;

InitializeNewYearsSettings(){
  this.NewYearSettings = null;
  this.NewYearSettings = {};
  this.NewYearSettings.DBID = 0;

  this.NewYearSettings.PartnerID = this.Partner?.ID;
  this.NewYearSettings.YearsBehind = 1;

  this.NewYearSettings.YearsBehindTargetYear = "";
  this.NewYearSettings.ExtraAddedPercentageValue = 0;
  this.NewYearSettings.OnlyPerosnalHistory = true;
  this.NewYearSettings.CompareHistoryPriceWithListPrice = false;

  const currentYear = new Date().getFullYear();
  this.NewYearSettings.YearsBehindTargetYear = (currentYear - this.NewYearSettings.YearsBehind).toString();
}

onYearsBehindChange(event: any) {
  if(this.NewYearSettings != null){
    const currentYear = new Date().getFullYear();
    this.NewYearSettings.YearsBehindTargetYear = (currentYear - this.NewYearSettings.YearsBehind).toString();
  }
}

restrictNonNumericInput(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode < 48 || charCode > 57) { // Allow only 0-9
    event.preventDefault();
  }
}


AddUpdateHistoryYearSetting(s){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    YearSetting:s,
  };
  
  this.parent.loading = true;
  
  this.service.AddUpdateHistoryYearSetting(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var setting = response["YearSetting"];
      const index = this.Partner.B2BSettings?.YearSettings?.findIndex(x => x.DBID === setting.DBID);

      if (index !== -1) {
        this.Partner.B2BSettings.YearSettings[index] = setting;
      }
      else{
        this.Partner.B2BSettings.YearSettings.push(setting);
      }
    }
  
    this.NewYearSettings = {};
    this.NewYearSettings = null;
    this.parent.loading = false;
   });
}

GetPartnersB2BHistoryYearSettings(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:this.Partner.ID
  };
  
  this.parent.loading = true;
  
  this.service.GetPartnersB2BHistoryYearSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Partner.B2BSettings.YearSettings = JSON.parse(JSON.stringify(response["YearSettings"]));
    }
  
    this.parent.loading = false;
   });
}

DeletePartnersB2BHistoryYearSettings(s:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:s.DBID
  };
  
  this.parent.loading = true;
  
  this.service.DeletePartnersB2BHistoryYearSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Partner.B2BSettings.YearSettings = this.Partner.B2BRestrictions.filter(x => x.DBID != s.DBID);
    }
  
    this.parent.loading = false;
   });
}

ShowYearSettingsBrandChange:boolean = false;

OpenYearSettingsBrandChange(){
  this.ShowYearSettingsBrandChange = true;
}

ShowNewYearSettingsBrandChange:boolean = false;

OpenNewYearSettingsBrandChange(){
  this.ShowNewYearSettingsBrandChange = true;
}

GetBrandsFilteredForYearSettings(searchTerm:string, page = 1){
    
  this.BrandFilter.Pager.PageIndex = page;
  this.BrandFilter.SearchTerm = searchTerm;
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.BrandFilter
    };

    this.managementService.GetBrandsFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Brands = response["Brands"];
  
       if(this.Brands.length == 1){
        this.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
        this.BrandSearchTerm = JSON.parse(JSON.stringify(this.Brand?.Name));

        this.Brands = [];
        this.BrandFilter.SearchTerm = "";
        
        if(this.CurrentYearSetting != null){
          this.CurrentYearSetting.Brand = JSON.parse(JSON.stringify(this.Brands[0])); 
        }
       }
      }
     });
}

GetBrandsFilteredForNewYearSettings(searchTerm:string, page = 1){
    
  this.BrandFilter.Pager.PageIndex = page;
  this.BrandFilter.SearchTerm = searchTerm;
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.BrandFilter
    };

    this.managementService.GetBrandsFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Brands = response["Brands"];
  
       if(this.Brands.length == 1){
        this.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
        this.BrandSearchTerm = JSON.parse(JSON.stringify(this.Brand?.Name));

        this.Brands = [];
        this.BrandFilter.SearchTerm = "";
        
        if(this.NewYearSettings != null){
          this.NewYearSettings.Brand = JSON.parse(JSON.stringify(this.Brands[0])); 
        }
       }
      }
     });
}

SelectBrandForYearsSetting(b:any){
  if(this.CurrentYearSetting != null){
    this.CurrentYearSetting.Brand = JSON.parse(JSON.stringify(b)); 
    this.ShowYearSettingsBrandChange = false;
  }
}

SelectBrandForNewYearsSetting(b:any){
  if(this.NewYearSettings != null){
    this.NewYearSettings.Brand = JSON.parse(JSON.stringify(b)); 
    this.ShowNewYearSettingsBrandChange = false;
  }
}

ShowGeneratePartnersSearchResultsPopUp:boolean = false;

ShowGeneratePartnersSearchResultsQuestion(){
  this.ShowGeneratePartnersSearchResultsPopUp = true;
}

GeneratePartnersSearchResults(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GeneratePartnersSearchResults(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.parent.loading = false;
     });
}

ShippingMasterData: {[k: string]: any} = {};
GeneralShippingServiceTypes:any[];
ShippingWays:any[];
ShippingCompanies:any[];
WeightTypes:any[];
Directions:any[];
ShowDeleteBoxQuestion:boolean;
CurrentBox:any;
ShippingDetails: {[k: string]: any} = {};
ShippingResponsabilities:any[];
ShippingResponsability:any;
ShippingServiceTypes:any[];
ShippingServiceType:any;

GetShippingMasterData(){
  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage()
 };

this.parent.loading = true;

this.managementService.GetShippingMasterData(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
   this.ShippingMasterData = JSON.parse(JSON.stringify(response));
   this.ShippingResponsabilities = response["ShippingResponsabilities"];
   this.GeneralShippingServiceTypes = response["ShippingServiceTypes"];
   this.ShippingServiceTypes = response["ShippingServiceTypes"];
   this.ShippingWays = response["ShippingWays"];
   this.ShippingCompanies = response["APIShippingCompanies"];
   this.WeightTypes = response["WeightTypes"];
   this.Directions = response["Directions"];

   this.ShippingResponsabilities.pop();

   this.ShippingDetails.ShippingDirection = this.Directions[0];
   this.ShippingDetails.WeightType = this.WeightTypes[0];
   this.ShippingDetails.ShippingWay = this.ShippingWays[0];
   this.ShippingDetails.ShippingResponsability = this.ShippingResponsabilities[1];
   this.ShippingDetails.ShippingServiceType = this.ShippingServiceTypes[0];
   this.Countries = this.parent.masterData.Countries;
   
   if(this.CurrentShippingAddress != null){
      var country = this.CurrentShippingAddress.Country;
      this.GetCountryShippingOptions(country);
   }
  }

  this.parent.loading = false;
 });
 }

 SelectShippingCompany(s:any){
  this.ShippingCompanies.forEach(element => {
    if (element.ID === s.ID) {
      element.IsSelected = true;
    } else {
      element.IsSelected = false;
    }
  });

  this.ShippingDetails.ShippingCompany = s;
 }

 SelectShippingServiceType(s:any){
  if(s != null){
    this.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(s));
    this.ShippingDetails.ShippingServiceType.IsSelected = true;

    this.ShippingDetails.ShippingCompany.ShippingServiceTypes.forEach(element => {
      element.IsSelected = false;
    });

    this.ShippingDetails.ShippingCompany.ShippingServiceTypes.filter(x => x.ID == this.ShippingDetails.ShippingServiceType.ID)[0].IsSelected = true;
  }
  else{
    this.ShippingDetails.ShippingCompany.ShippingServiceTypes = [];
  }
}

 GetCountryShippingOptions(Country:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Country:Country,
    PartnerID:this.Partner?.ID,
    DirectionID:this.ShippingDetails.ShippingDirection?.ID,
    ShippingCompany:this.ShippingCompanies[0]
  };

 this.parent.loading = true;

 this.managementService.GetCountryShippingOptions(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
     this.ShippingCompanies = response["ShippingCompanies"];

     if(this.ShippingCompanies.some(x => x.IsSelected == true)){
        this.SelectShippingCompany(this.ShippingCompanies.filter(x => x.IsSelected == true)[0]);
     }
     else if(this.ShippingCompanies != null && this.ShippingCompanies.length > 0){
      this.SelectShippingCompany(this.ShippingCompanies[0]);
     }
   }

   this.parent.loading = false;
   });
}

SendDispatchEmailClientRequest(){

  this.Partner.PartnerAgents = this.PartnerAgents; 

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.Partner,
    ShippingDetails:this.ShippingDetails,
    Items:this.ReadyItems,
    ClientMessage:this.ClientMessage,
  };

 this.parent.loading = true;
 this.ShowShipmentRequestPopup = false;

 this.B2BService.SendDispatchEmailClientRequest(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
   }
   
   this.parent.loading = false;
   });
}

ShowShipmentRequestPopup:boolean = false;
ClientMessage:string;
ReadyItems:any[];
ReadyItemsTotal:any;
ReadyItemsTotalCurrency:string;

// ========== MASS EMAIL FUNCTIONALITY ==========
ShowMassEmailPopup:boolean = false;
ShowMassEmailResultsPopup:boolean = false;
MassEmailSending:boolean = false;

// MASS Email - All Partner Agents with Partner info
AllPartnerAgents:any[] = [];
GroupedPartners:any[] = [];

// MASS Email - Results counts (pre-calculated to avoid template method calls)
MassEmailSuccessCount:number = 0;
MassEmailErrorCount:number = 0;
SelectedAgentsCount:number = 0;
TotalAgentsCount:number = 0;

// MASS Email - Department Filter
MassEmailDepartmentFilter:any[] = [];
showMassEmailDepartmentDropdown:boolean = false;

// MASS Email - Search Filter
MassEmailSearchQuery:string = '';
MassEmailVisiblePartnersCount:number = 0;
MassEmailTotalPartnersCount:number = 0;
MassEmailIsFiltered:boolean = false;

// MASS Email - SMTP Configuration
MassEmailSMTPConfigs:any[] = [];
MassEmailCurrentSMTP:any = null;
MassEmailSMTPEmails:any[] = [];
MassEmailCurrentSMTPEmail:any = null;
showMassEmailSMTPDropdown:boolean = false;
showMassEmailSMTPEmailDropdown:boolean = false;

// MASS Email - Message Composition
MassEmailSubject:string = '';
MassEmailBody:string = '';
MassEmailUseSignature:boolean = false;

// MASS Email - Attachments
MassEmailAttachments:any[] = [];
MassEmailAttachmentInput:any;

// MASS Email - Progress Tracking (SignalR)
MassEmailProgressPercent:number = 0;
MassEmailProgressTotal:number = 0;
MassEmailProgressCompleted:number = 0;
MassEmailShowProgressPopup:boolean = false;

// MASS Email - 2-Step Confirmation Dialog
ShowMassEmailConfirmation:boolean = false;
MassEmailConfirmationCode:string = '';
MassEmailConfirmationDigits:string[] = ['', '', '', ''];
MassEmailConfirmationError:string = '';
MassEmailConfirmationRecipientCount:number = 0;

// MASS Email - History Tab
MassEmailActiveTab:string = 'compose'; // 'compose' or 'history'
MassEmailHistory:any[] = [];
MassEmailHistoryLoading:boolean = false;
MassEmailHistoryDateFrom:any = null;
MassEmailHistoryDateTo:any = null;

GetB2BClientOCReadyItemsUX(p:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:p,
  };

  this.parent.loading = true;

  this.B2BService.GetB2BClientOCReadyItemsUX(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ReadyItems = response["Items"];
      this.ReadyItemsTotal = response["ReadyItemsTotal"];
      this.ReadyItemsTotalCurrency = response["ReadyItemsTotalCurrency"];
      this.GetPartnerShippingAddresses(this.Partner?.ID);
      this.GetPartnerAgents(this.Partner?.ID, true);
    }

    this.parent.loading = false;
   });
}

// ========== PARTNER CARRIER ACCOUNTS ==========

GetPartnerCarrierAccounts(partnerID: string) {
  if (!partnerID) return;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Filter: {
      PartnerID: partnerID,
      Pager: { PageIndex: 1, PageSize: 100 }
    }
  };

  this.loadingPartnerAccounts = true;
  this.PartnerAccountDirections = this.parent.CartMasterData?.Directions || [];

  this.managementService.GetShippingCompanyAccountsFiltered(request).subscribe(response => {
    if (response["Status"] == 1) {
      this.PartnerCarrierAccounts = JSON.parse(JSON.stringify(response["ShippingCompanyAccounts"]));
    }
    this.loadingPartnerAccounts = false;
  });
}

InitializeNewPartnerAccount() {
  this.CurrentPartnerAccount = {};
  this.CurrentPartnerAccount.ID = 0;
  this.CurrentPartnerAccount.FKShippingCompanyID = null;
  this.CurrentPartnerAccount.AccountNumber = "";
  this.CurrentPartnerAccount.FKCompanyID = null;
  this.CurrentPartnerAccount.PartnerID = this.Partner?.ID;
  this.CurrentPartnerAccount.ShippingDirection = null;
  this.CurrentPartnerAccount.ShippingServiceType = null;
  this.CurrentPartnerAccount.ShippingCompany = null;
  this.CurrentPartnerAccount.Direction = null;
  this.CurrentPartnerAccount.ServiceType = null;
}

OpenNewPartnerAccountPopUp() {
  this.InitializeNewPartnerAccount();
  this.ShowPartnerAccountPopUp = true;
}

EditPartnerAccount(account: any) {
  this.CurrentPartnerAccount = JSON.parse(JSON.stringify(account));
  this.CurrentPartnerAccount.ShippingCompany = this.parent.CartMasterData?.ShippingCompanies?.find((x: any) => x.ID == account.FKShippingCompanyID) || null;
  this.CurrentPartnerAccount.Direction = this.PartnerAccountDirections?.find((x: any) => x.ID == account.ShippingDirection) || null;
  this.CurrentPartnerAccount.ServiceType = this.parent.CartMasterData?.ShippingServiceTypes?.find((x: any) => x.ID == account.ShippingServiceType) || null;
  this.ShowPartnerAccountPopUp = true;
}

ClosePartnerAccountPopUp() {
  this.ShowPartnerAccountPopUp = false;
  this.CurrentPartnerAccount = null;
  this.showPartnerAccountShippingCompanyDropdown = false;
  this.showPartnerAccountDirectionDropdown = false;
  this.showPartnerAccountServiceTypeDropdown = false;
}

SavePartnerAccount() {
  if (!this.CurrentPartnerAccount.ShippingCompany) {
    this.parent.openSnackBar("Please select a shipping company", "OK", "alert-info-snackbar");
    return;
  }

  this.CurrentPartnerAccount.FKShippingCompanyID = this.CurrentPartnerAccount.ShippingCompany?.ID;
  this.CurrentPartnerAccount.ShippingDirection = this.CurrentPartnerAccount.Direction || null;
  this.CurrentPartnerAccount.ShippingServiceType = this.CurrentPartnerAccount.ServiceType || null;
  this.CurrentPartnerAccount.PartnerID = this.Partner?.ID;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    ShippingCompanyAccount: this.CurrentPartnerAccount
  };

  this.loadingPartnerAccounts = true;

  this.managementService.AddUpdateShippingCompanyAccount(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      this.parent.openSnackBar("Account saved successfully", "OK", "light-info-snackbar");
      this.ClosePartnerAccountPopUp();
      this.GetPartnerCarrierAccounts(this.Partner?.ID);
    }
    this.loadingPartnerAccounts = false;
  });
}

DeletePartnerAccount(account: any) {
  if (!confirm("Are you sure you want to delete this account?")) {
    return;
  }

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    ID: account.ID
  };

  this.loadingPartnerAccounts = true;

  this.managementService.DeleteShippingCompanyAccount(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      this.parent.openSnackBar("Account deleted successfully", "OK", "light-info-snackbar");
      this.GetPartnerCarrierAccounts(this.Partner?.ID);
    }
    this.loadingPartnerAccounts = false;
  });
}

// ========== MASS EMAIL METHODS ==========

OpenMassEmailPopup(){
  this.ShowMassEmailPopup = true;
  this.MassEmailSubject = '';
  this.MassEmailBody = '';
  this.MassEmailUseSignature = false;
  this.MassEmailAttachments = [];
  this.MassEmailDepartmentFilter = [];
  this.MassEmailSearchQuery = '';
  this.MassEmailVisiblePartnersCount = 0;
  this.MassEmailTotalPartnersCount = 0;
  this.MassEmailIsFiltered = false;
  this.GroupedPartners = [];
  this.AllPartnerAgents = [];
  this.GetAllPartnerAgents();
  this.GetMassEmailSMTPConfigs();
}

CloseMassEmailPopup(){
  this.ShowMassEmailPopup = false;
  this.MassEmailSubject = '';
  this.MassEmailBody = '';
  this.MassEmailUseSignature = false;
  this.MassEmailAttachments = [];
  this.AllPartnerAgents = [];
  this.GroupedPartners = [];
  this.MassEmailSearchQuery = '';
  this.MassEmailVisiblePartnersCount = 0;
  this.MassEmailTotalPartnersCount = 0;
  this.MassEmailIsFiltered = false;
  this.MassEmailActiveTab = 'compose';
  this.MassEmailHistory = [];
  this.MassEmailHistoryDateFrom = null;
  this.MassEmailHistoryDateTo = null;
}

SwitchMassEmailTab(tab: string){
  this.MassEmailActiveTab = tab;
  if(tab === 'history' && this.MassEmailHistory.length === 0){
    this.GetMassEmailHistory();
  }
}

GetMassEmailHistory(){
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    CompanyID: this.parent.Company?.ID,
    DateFrom: this.MassEmailHistoryDateFrom ? this.MassEmailHistoryDateFrom.toDate() : null,
    DateTo: this.MassEmailHistoryDateTo ? this.MassEmailHistoryDateTo.toDate() : null
  };

  this.MassEmailHistoryLoading = true;

  this.service.GetMassEmailHistory(request).subscribe(response => {
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MassEmailHistory = response["Messages"] || [];
    }

    this.MassEmailHistoryLoading = false;
  });
}

ToggleMassMessageExpanded(message: any){
  message.IsExpanded = !message.IsExpanded;
}

DownloadMassMessageAttachment(attachment: any){
  if(!attachment?.ID) return;

  this.service.DownloadMassMessageAttachment(attachment.ID).subscribe({
    next: (blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = attachment.FileName || 'attachment';
      link.click();
      window.URL.revokeObjectURL(url);
    },
    error: (err) => {
      console.error('Download failed:', err);
      this.parent.openSnackBar('Failed to download attachment', 'OK', 'alert-info-snackbar');
    }
  });
}

GetAllPartnerAgents(){
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    CompanyID: this.parent.Company?.ID
  };

  this.parent.loading = true;

  this.service.GetAllPartnerAgents(request).subscribe(response => {
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      // Backend now returns Partners with nested PartnerAgents
      const partners = response["Partners"] || [];
      // Use departments from masterData (already populated on init)
      this.Departments = this.parent.masterData?.Departments || [];

      // Flatten all agents for the results list and build grouped structure
      this.AllPartnerAgents = [];
      this.GroupedPartners = [];

      partners.forEach((partner: any) => {
        const agents = partner.PartnerAgents || [];

        // Add IsSelected flag to each agent and collect in flat list
        agents.forEach((agent: any) => {
          agent.IsSelected = false;
          agent.IsHidden = false;
          this.AllPartnerAgents.push(agent);
        });

        // Create grouped structure for UI
        if(agents.length > 0){
          this.GroupedPartners.push({
            Partner: partner,
            Agents: agents,
            IsExpanded: false,
            AllSelected: false,
            SomeSelected: false
          });
        }
      });

      this.UpdateGroupSelectionStates();
      this.ApplyMassEmailDepartmentFilter();
    }

    this.parent.loading = false;
  });
}

ApplyMassEmailFilters(){
  const searchQuery = (this.MassEmailSearchQuery || '').toLowerCase().trim();
  const hasDeptFilter = this.MassEmailDepartmentFilter && this.MassEmailDepartmentFilter.length > 0;
  const selectedDeptIds = hasDeptFilter ? this.MassEmailDepartmentFilter.map((d: any) => d.ID) : [];

  this.MassEmailTotalPartnersCount = this.GroupedPartners.length;
  let visiblePartnersCount = 0;

  this.GroupedPartners.forEach(group => {
    const partnerName = (group.Partner?.Name || '').toLowerCase();
    let visibleAgentsCount = 0;

    group.Agents.forEach((agent: any) => {
      // Check search filter (match partner name OR agent email OR agent name)
      const agentEmail = (agent.Email || '').toLowerCase();
      const agentName = ((agent.FirstName || '') + ' ' + (agent.LastName || '')).toLowerCase();
      const passesSearchFilter = !searchQuery ||
        partnerName.includes(searchQuery) ||
        agentEmail.includes(searchQuery) ||
        agentName.includes(searchQuery);

      // Visibility is controlled ONLY by search filter
      agent.IsHidden = !passesSearchFilter;

      // Selection is controlled by department filter
      // If department filter is active: select only agents matching selected departments
      // If no department filter: keep current selection (or select all if first load)
      if(hasDeptFilter){
        agent.IsSelected = selectedDeptIds.includes(agent.Department?.ID);
      }

      if(!agent.IsHidden){
        visibleAgentsCount++;
      }
    });

    // Track visible agents count and if this group has visible agents
    group.VisibleAgentsCount = visibleAgentsCount;
    group.IsGroupHidden = visibleAgentsCount === 0;
    if(visibleAgentsCount > 0){
      visiblePartnersCount++;
    }
  });

  this.MassEmailVisiblePartnersCount = visiblePartnersCount;
  this.MassEmailIsFiltered = !!searchQuery || hasDeptFilter;

  this.UpdateGroupSelectionStates();
  this.UpdateSelectedAgentsCount();
}

// Legacy method name for backward compatibility
ApplyMassEmailDepartmentFilter(){
  this.ApplyMassEmailFilters();
}

OnMassEmailSearchChange(){
  this.ApplyMassEmailFilters();
}

ClearMassEmailSearch(){
  this.MassEmailSearchQuery = '';
  this.ApplyMassEmailFilters();
}

ToggleMassEmailDepartment(dept: any){
  const index = this.MassEmailDepartmentFilter.findIndex((d: any) => d.ID === dept.ID);
  if(index >= 0){
    this.MassEmailDepartmentFilter.splice(index, 1);
  } else {
    this.MassEmailDepartmentFilter.push(dept);
  }
  this.ApplyMassEmailFilters();
}

IsDepartmentSelected(dept: any): boolean {
  return this.MassEmailDepartmentFilter.some((d: any) => d.ID === dept.ID);
}

AreAllDepartmentsSelected(): boolean {
  return this.Departments && this.Departments.length > 0 &&
         this.MassEmailDepartmentFilter.length === this.Departments.length;
}

ToggleAllDepartments(){
  if(this.AreAllDepartmentsSelected()){
    // All are selected -> Deselect all departments and deselect all agents
    this.MassEmailDepartmentFilter = [];
    this.AllPartnerAgents.forEach(agent => {
      agent.IsSelected = false;
    });
  } else {
    // Not all selected -> Select all departments (which will select all agents)
    this.MassEmailDepartmentFilter = [...this.Departments];
  }
  this.ApplyMassEmailFilters();
}

TogglePartnerExpanded(group: any){
  group.IsExpanded = !group.IsExpanded;
}

ToggleAllPartnerAgents(group: any){
  const visibleAgents = group.Agents.filter((a: any) => !a.IsHidden);
  const allSelected = visibleAgents.every((a: any) => a.IsSelected);
  visibleAgents.forEach((agent: any) => {
    agent.IsSelected = !allSelected;
  });
  this.UpdateGroupSelectionStates();
  this.UpdateSelectedAgentsCount();
}

ToggleAgentSelection(agent: any){
  agent.IsSelected = !agent.IsSelected;
  this.UpdateGroupSelectionStates();
  this.UpdateSelectedAgentsCount();
}

SelectAllMassEmailAgents(){
  this.AllPartnerAgents.forEach(agent => {
    if(!agent.IsHidden){
      agent.IsSelected = true;
    }
  });
  this.UpdateGroupSelectionStates();
  this.UpdateSelectedAgentsCount();
}

DeselectAllMassEmailAgents(){
  this.AllPartnerAgents.forEach(agent => {
    agent.IsSelected = false;
  });
  this.UpdateGroupSelectionStates();
  this.UpdateSelectedAgentsCount();
}

UpdateGroupSelectionStates(){
  this.GroupedPartners.forEach(group => {
    const visibleAgents = group.Agents.filter((a: any) => !a.IsHidden);
    if(visibleAgents.length === 0){
      group.AllSelected = false;
      group.SomeSelected = false;
    } else {
      group.AllSelected = visibleAgents.every((a: any) => a.IsSelected);
      group.SomeSelected = !group.AllSelected && visibleAgents.some((a: any) => a.IsSelected);
    }
  });
}

UpdateSelectedAgentsCount(){
  this.SelectedAgentsCount = this.AllPartnerAgents.filter(a => a.IsSelected && !a.IsHidden).length;
  this.TotalAgentsCount = this.AllPartnerAgents.length;
}

GetMassEmailSMTPConfigs(){
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    UILanguage: this.parent.getLanguage(),
    CompanyID: this.parent.Company?.ID
  };

  this.service.GetCompanySMTPConfigs(request).subscribe(response => {
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MassEmailSMTPConfigs = response["SMTPConfigs"] || [];
      if(this.MassEmailSMTPConfigs.length > 0){
        this.MassEmailCurrentSMTP = this.MassEmailSMTPConfigs[0];
        this.GetMassEmailSMTPEmails(this.MassEmailCurrentSMTP.ID);
      }
    }
  });
}

GetMassEmailSMTPEmails(SMTPID: any){
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    UILanguage: this.parent.getLanguage(),
    SMTPID: SMTPID
  };

  this.service.GetCompanySMTPEmails(request).subscribe(response => {
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MassEmailSMTPEmails = response["Emails"] || [];
      if(this.MassEmailSMTPEmails.length > 0){
        // Try to find the current user's email, otherwise use the first one
        this.MassEmailCurrentSMTPEmail = this.MassEmailSMTPEmails.find((x: any) => x.Email === this.parent.User.Email) || this.MassEmailSMTPEmails[0];
      }
    }
  });
}

SelectMassEmailSMTP(smtp: any){
  this.MassEmailCurrentSMTP = smtp;
  this.showMassEmailSMTPDropdown = false;
  this.GetMassEmailSMTPEmails(smtp.ID);
}

SelectMassEmailSMTPEmail(email: any){
  this.MassEmailCurrentSMTPEmail = email;
  this.showMassEmailSMTPEmailDropdown = false;
}

// File attachment handling
OnMassEmailFileSelected(event: any){
  const files = event.target.files;
  if(!files || files.length === 0) return;

  for(let i = 0; i < files.length; i++){
    const file = files[i];

    // Validate file size - 20MB limit
    const maxSize = 20 * 1024 * 1024;
    if(file.size > maxSize){
      this.parent.openSnackBar('File size must be less than 20MB.', 'OK', 'alert-info-snackbar');
      continue;
    }

    // Convert to Base64
    const reader = new FileReader();
    reader.onload = () => {
      const base64File = (reader.result as string).split(',')[1];
      this.MassEmailAttachments.push({
        FileName: file.name,
        FileSize: file.size,
        Base64Content: base64File,
        MimeType: file.type
      });
    };
    reader.readAsDataURL(file);
  }

  // Clear the input
  event.target.value = '';
}

RemoveMassEmailAttachment(index: number){
  this.MassEmailAttachments.splice(index, 1);
}

FormatFileSize(bytes: number): string {
  if(bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// ============================================
// MASS EMAIL - 2-STEP CONFIRMATION DIALOG
// ============================================

/**
 * Shows the confirmation popup with a random 4-digit code.
 * User must enter this code to proceed with sending emails.
 */
ShowMassEmailConfirmationPopup(){
  // Permission check - only "Management" users can send MASS emails
  if(this.parent.User?.UserManagementInfo?.Title !== 'Management'){
    this.parent.openSnackBar(this.parent.translate.instant('MassEmailNoRights'), 'OK', 'alert-info-snackbar');
    return;
  }

  // Validation first - same as SendMassEmail
  if(!this.MassEmailSubject || this.MassEmailSubject.trim().length === 0){
    this.parent.openSnackBar('Please enter an email subject.', 'OK', 'alert-info-snackbar');
    return;
  }

  if(!this.MassEmailBody || this.MassEmailBody.trim().length === 0){
    this.parent.openSnackBar('Please enter an email message.', 'OK', 'alert-info-snackbar');
    return;
  }

  const selectedAgents = this.AllPartnerAgents.filter(a => a.IsSelected && !a.IsHidden);
  if(selectedAgents.length === 0){
    this.parent.openSnackBar('Please select at least one recipient.', 'OK', 'alert-info-snackbar');
    return;
  }

  if(!this.MassEmailCurrentSMTP || !this.MassEmailCurrentSMTPEmail){
    this.parent.openSnackBar('SMTP configuration is not available.', 'OK', 'alert-info-snackbar');
    return;
  }

  // Generate confirmation code and show popup
  this.MassEmailConfirmationRecipientCount = selectedAgents.length;
  this.MassEmailConfirmationCode = this.GenerateConfirmationCode();
  this.MassEmailConfirmationDigits = ['', '', '', ''];
  this.MassEmailConfirmationError = '';
  this.ShowMassEmailConfirmation = true;

  // Auto-focus first input after popup renders
  setTimeout(() => {
    const firstInput = document.getElementById('confirm-digit-0');
    if(firstInput) firstInput.focus();
  }, 100);
}

/**
 * Generates a random 4-digit confirmation code.
 */
GenerateConfirmationCode(): string {
  return Math.floor(1000 + Math.random() * 9000).toString();
}

/**
 * Handles input in confirmation digit boxes.
 * Auto-moves focus to next box after entering a digit.
 * @param nextInput - Template reference to the next input element (or null for last)
 */
OnConfirmationDigitInput(event: any, index: number, nextInput: HTMLInputElement | null){
  let value = event.target.value;

  // Only allow digits (0-9)
  value = value.replace(/[^0-9]/g, '');

  // Only keep last character if multiple pasted
  if(value.length > 1){
    value = value.charAt(value.length - 1);
  }

  // Update input and array
  event.target.value = value;
  this.MassEmailConfirmationDigits[index] = value;

  // Clear error when user starts typing
  this.MassEmailConfirmationError = '';

  // Auto-focus next input if digit entered
  if(value && nextInput){
    nextInput.focus();
    nextInput.select();
  }
}

/**
 * Handles backspace key in confirmation digit boxes.
 * Moves focus to previous box when current is empty.
 * @param prevInput - Template reference to the previous input element (or null for first)
 */
OnConfirmationDigitKeydown(event: KeyboardEvent, _index: number, prevInput: HTMLInputElement | null){
  const currentValue = (event.target as HTMLInputElement).value;
  if(event.key === 'Backspace' && !currentValue && prevInput){
    prevInput.focus();
    prevInput.select();
  }
}

/**
 * Validates if all 4 digits are entered correctly.
 */
IsConfirmationCodeValid(): boolean {
  const enteredCode = this.MassEmailConfirmationDigits.join('');
  return enteredCode.length === 4 && enteredCode === this.MassEmailConfirmationCode;
}

/**
 * Checks if all 4 digit boxes are filled (for button enable state).
 */
IsConfirmationCodeComplete(): boolean {
  return this.MassEmailConfirmationDigits.every(d => d !== '');
}

/**
 * Called when user clicks "Confirm Send" button.
 * Validates code and proceeds with actual email sending.
 */
ConfirmAndSendMassEmail(){
  if(!this.IsConfirmationCodeValid()){
    this.MassEmailConfirmationError = 'Incorrect code. Please try again.';
    this.ClearConfirmationInputs();
    setTimeout(() => {
      const firstInput = document.getElementById('confirm-digit-0') as HTMLInputElement;
      if(firstInput) firstInput.focus();
    }, 50);
    return;
  }

  // Code is valid - close confirmation popup and start sending
  this.ShowMassEmailConfirmation = false;
  this.ClearConfirmationInputs();
  this.SendMassEmail();
}

/**
 * Cancels the confirmation and closes the popup.
 */
CancelMassEmailConfirmation(){
  this.ShowMassEmailConfirmation = false;
  this.MassEmailConfirmationCode = '';
  this.MassEmailConfirmationError = '';
  this.ClearConfirmationInputs();
}

/**
 * Clears all confirmation digit inputs (both DOM and array).
 */
ClearConfirmationInputs(){
  this.MassEmailConfirmationDigits = ['', '', '', ''];
  // Also clear the actual DOM input values
  for(let i = 0; i < 4; i++){
    const input = document.getElementById('confirm-digit-' + i) as HTMLInputElement;
    if(input) input.value = '';
  }
}

async SendMassEmail(){
  // Validation
  if(!this.MassEmailSubject || this.MassEmailSubject.trim().length === 0){
    this.parent.openSnackBar('Please enter an email subject.', 'OK', 'alert-info-snackbar');
    return;
  }

  if(!this.MassEmailBody || this.MassEmailBody.trim().length === 0){
    this.parent.openSnackBar('Please enter an email message.', 'OK', 'alert-info-snackbar');
    return;
  }

  const selectedAgents = this.AllPartnerAgents.filter(a => a.IsSelected && !a.IsHidden);
  if(selectedAgents.length === 0){
    this.parent.openSnackBar('Please select at least one recipient.', 'OK', 'alert-info-snackbar');
    return;
  }

  if(!this.MassEmailCurrentSMTP || !this.MassEmailCurrentSMTPEmail){
    this.parent.openSnackBar('SMTP configuration is not available.', 'OK', 'alert-info-snackbar');
    return;
  }

  // Initialize progress tracking
  this.MassEmailProgressPercent = 0;
  this.MassEmailProgressCompleted = 0;
  this.MassEmailProgressTotal = selectedAgents.length;
  this.MassEmailSuccessCount = 0;
  this.MassEmailErrorCount = 0;
  this.MassEmailShowProgressPopup = true;
  this.MassEmailSending = true;

  // Clean up any existing subscriptions
  this.cleanupSignalRSubscriptions();

  try {
    // Connect to SignalR hub
    this.signalRConnectionId = await this.signalRService.connect();
    console.log('📧 Mass Email - SignalR connected:', this.signalRConnectionId);

    // Subscribe to progress updates
    const progressSub = this.signalRService.massEmailProgress$.subscribe((update: MassEmailProgressUpdate) => {
      console.log('📬 SignalR MassEmailProgress received:', JSON.stringify(update));
      this.ngZone.run(() => {
        this.handleMassEmailProgressUpdate(update);
      });
    });
    this.signalRSubscriptions.push(progressSub);

    // Subscribe to completion
    const completeSub = this.signalRService.massEmailComplete$.subscribe((message: MassEmailCompleteMessage) => {
      console.log('📬 SignalR MassEmailComplete received:', JSON.stringify(message));
      this.ngZone.run(() => {
        this.handleMassEmailComplete(message);
      });
    });
    this.signalRSubscriptions.push(completeSub);

  } catch (error) {
    console.error('❌ Mass Email - SignalR connection failed:', error);
    // Continue without real-time updates
    this.signalRConnectionId = null;
  }

  // Build attachments with correct property names for backend
  const attachments = this.MassEmailAttachments.map((att: any) => ({
    Name: att.FileName,        // Original filename with extension
    PDFStream: att.Base64Content  // Base64 string - backend auto-converts to ByteStream
  }));

  // Build request with SignalR connection ID
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    SMTP: this.MassEmailCurrentSMTP,
    FromEmail: this.MassEmailCurrentSMTPEmail,
    Subject: this.MassEmailSubject,
    Body: this.MassEmailBody,
    UseSignature: this.MassEmailUseSignature,
    SignatureHtml: this.MassEmailUseSignature ? this.parent.User?.UserManagementInfo?.SignatureModel : null,
    Attachments: attachments,
    Recipients: selectedAgents,
    SignalRConnectionId: this.signalRConnectionId
  };

  this.service.SendMassEmail(request).subscribe(response => {
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      this.MassEmailSending = false;
      this.MassEmailShowProgressPopup = false;
      this.cleanupSignalRSubscriptions();
    }
    else if(response["Status"] == 1){
      // Final update from API response (in case SignalR missed any)
      const results = response["Results"] || [];
      results.forEach((result: any) => {
        const agent = this.AllPartnerAgents.find(a => a.ID === result.ID);
        if(agent){
          const sendStatus = result.EmailSendStatus;
          agent.EmailSendStatus = sendStatus?.Success ? 'Success' : 'Error';
          agent.EmailSendError = sendStatus?.Error || '';
        }
      });

      // Pre-calculate success/error counts
      this.MassEmailSuccessCount = this.AllPartnerAgents.filter(a => a.EmailSendStatus === 'Success').length;
      this.MassEmailErrorCount = this.AllPartnerAgents.filter(a => a.EmailSendStatus === 'Error').length;
      this.MassEmailProgressPercent = 100;

      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.ShowMassEmailPopup = false;
      this.MassEmailShowProgressPopup = false;
      this.ShowMassEmailResultsPopup = true;
      this.MassEmailSending = false;
      this.cleanupSignalRSubscriptions();
    }
  });
}

handleMassEmailProgressUpdate(update: MassEmailProgressUpdate){
  // Update progress tracking
  this.MassEmailProgressCompleted = update.CompletedCount;
  this.MassEmailProgressPercent = update.ProgressPercent;
  this.MassEmailSuccessCount = update.SuccessCount;
  this.MassEmailErrorCount = update.FailedCount;

  // Update the specific agent's status in real-time
  const agent = this.AllPartnerAgents.find(a => a.ID === update.AgentID);
  if(agent){
    agent.EmailSendStatus = update.Success ? 'Success' : 'Error';
    agent.EmailSendError = update.ErrorMessage || '';
  }

  console.log(`📧 Progress: ${update.CompletedCount}/${update.TotalCount} (${update.ProgressPercent}%)`);
}

handleMassEmailComplete(message: MassEmailCompleteMessage){
  console.log('📧 Mass Email batch completed:', message);
  this.MassEmailProgressPercent = 100;
  this.MassEmailSuccessCount = message.SuccessCount;
  this.MassEmailErrorCount = message.FailedCount;
}

CloseMassEmailResultsPopup(){
  this.ShowMassEmailResultsPopup = false;
  this.AllPartnerAgents = [];
  this.GroupedPartners = [];
  this.MassEmailSuccessCount = 0;
  this.MassEmailErrorCount = 0;
}

// Public Link Generation
GeneratePublicLink(partner: any) {
  const baseUrl = window.location.origin;
  this.PublicLinkUrl = `${baseUrl}/external/partner?id=${partner.ID}`;
  this.ShowPublicLinkPopup = true;
}

CopyPublicLinkToClipboard() {
  navigator.clipboard.writeText(this.PublicLinkUrl).then(() => {
    this.ShowPublicLinkPopup = false;
  });
}

ClosePublicLinkPopup() {
  this.ShowPublicLinkPopup = false;
  this.PublicLinkUrl = '';
}

// B2B Registration Link Generation
ShowB2BRegistrationLinkPopup: boolean = false;
B2BRegistrationLinkUrl: string = '';

GenerateB2BRegistrationLink(partner: any) {
  const baseUrl = window.location.origin;
  const vxrtmkd = btoa(partner.ID);              // vxrtmkd = partner ID
  const bnqfwlz = btoa(this.parent.User?.Id || ''); // bnqfwlz = admin user ID
  const jpthscx = btoa(String(this.parent.Company?.ID || '')); // jpthscx = company ID
  // Date as dd-MM-yyyy
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  const kwdrmvf = btoa(`${dd}-${mm}-${yyyy}`);   // kwdrmvf = link generation date
  this.B2BRegistrationLinkUrl = `${baseUrl}/b2b/register?vxrtmkd=${vxrtmkd}&bnqfwlz=${bnqfwlz}&jpthscx=${jpthscx}&kwdrmvf=${kwdrmvf}`;
  this.ShowB2BRegistrationLinkPopup = true;
}

CopyB2BRegistrationLinkToClipboard() {
  navigator.clipboard.writeText(this.B2BRegistrationLinkUrl).then(() => {
    this.parent.openSnackBar(this.parent.translate.instant('B2BRegistrationLinkCopied'), 'OK', 'alert-success-snackbar');
    this.ShowB2BRegistrationLinkPopup = false;
  });
}

CloseB2BRegistrationLinkPopup() {
  this.ShowB2BRegistrationLinkPopup = false;
  this.B2BRegistrationLinkUrl = '';
}

// Accepted Email Domains

GetPartnerAcceptedDomains(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:this.Partner.ID
  };

  this.parent.loading = true;

  this.service.GetPartnerAcceptedDomains(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.AcceptedDomains = JSON.parse(JSON.stringify(response["Domains"]));
    }

    this.parent.loading = false;
   });
}

IsValidAcceptedDomainFormat(value:string):boolean{
  if(value == null || value.trim().length == 0) return false;
  var pattern = /^@[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+$/;
  return pattern.test(value.trim());
}

AddUpdatePartnerAcceptedDomain(){

  if(this.NewAcceptedEmailDomain == null || this.NewAcceptedEmailDomain.trim().length == 0){
    return;
  }

  if(!this.IsValidAcceptedDomainFormat(this.NewAcceptedEmailDomain)){
    this.InvalidAcceptedDomainFormat = true;
    return;
  }

  this.InvalidAcceptedDomainFormat = false;

  var domain = {
    DBID: 0,
    FKPartnerID: this.Partner.ID,
    EmailDomain: this.NewAcceptedEmailDomain.trim()
  };

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Domain:domain
  };

  this.parent.loading = true;

  this.service.AddUpdatePartnerAcceptedDomain(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.NewAcceptedEmailDomain = '';
      this.GetPartnerAcceptedDomains();
    }

    this.parent.loading = false;
   });
}

PrepareAcceptedDomainDelete(domain:any){
  this.DeletingAcceptedDomain = JSON.parse(JSON.stringify(domain));
  this.ShowDeleteAcceptedDomainQuestion = true;
}

DeletePartnerAcceptedDomain(domain:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:domain.DBID
  };

  this.parent.loading = true;

  this.service.DeletePartnerAcceptedDomain(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.AcceptedDomains = this.AcceptedDomains.filter(x => x.DBID != domain.DBID);
      this.ShowDeleteAcceptedDomainQuestion = false;
    }

    this.parent.loading = false;
   });
}

// ========== DEFAULT AGENT PHASES MANAGEMENT ==========
showDefaultPhasesPopup: boolean = false;
selectedDefaultPhaseAgent: any = null;
defaultPhasesMasterData: any[] = [];
selectedDefaultPhaseIDs: number[] = [];
savingDefaultPhases: boolean = false;

openDefaultPhasesPopup(): void {
  if (!this.PartnerAgent?.ID) return;
  this.selectedDefaultPhaseAgent = this.PartnerAgent;

  // Load masterdata if needed
  if (this.defaultPhasesMasterData.length === 0) {
    const request = { User: this.parent.User, Language: this.parent.getLanguage() };
    this.service.GetPartnersMasterData(request).subscribe((response: any) => {
      if (response.Status === 1) {
        this.defaultPhasesMasterData = response.PartnerAgentOrderPhases || [];
      }
    });
  }

  // Load current default phases for this agent
  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    AgentID: this.PartnerAgent.ID
  };
  this.parent.loading = true;
  this.service.GetPartnerAgentDefaultPhases(request).subscribe((response: any) => {
    this.parent.loading = false;
    if (response.Status === 1) {
      this.PartnerAgent.OrderPhases = response.Phases || [];
      this.selectedDefaultPhaseIDs = (response.Phases || []).map((p: any) => p.ID);
    }
    this.showDefaultPhasesPopup = true;
  });
}

closeDefaultPhasesPopup(): void {
  this.showDefaultPhasesPopup = false;
}

isDefaultPhaseSelected(phase: any): boolean {
  return this.selectedDefaultPhaseIDs.includes(phase.ID);
}

toggleDefaultPhase(phase: any): void {
  const idx = this.selectedDefaultPhaseIDs.indexOf(phase.ID);
  if (idx >= 0) {
    this.selectedDefaultPhaseIDs.splice(idx, 1);
  } else {
    this.selectedDefaultPhaseIDs.push(phase.ID);
  }
}

toggleAllDefaultPhases(phase: any): void {
  // Double-click: the clicked phase gets toggled first (by click),
  // then we set ALL phases to match the new state of the clicked phase
  const isNowSelected = this.selectedDefaultPhaseIDs.includes(phase.ID);
  if (isNowSelected) {
    this.selectedDefaultPhaseIDs = this.defaultPhasesMasterData.map((p: any) => p.ID);
  } else {
    this.selectedDefaultPhaseIDs = [];
  }
}

saveDefaultPhases(): void {
  if (!this.selectedDefaultPhaseAgent || this.savingDefaultPhases) return;

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    AgentID: this.selectedDefaultPhaseAgent.ID,
    PhaseIDs: this.selectedDefaultPhaseIDs
  };

  this.savingDefaultPhases = true;
  this.service.AddUpdatePartnerAgentDefaultPhases(request).subscribe((response: any) => {
    this.savingDefaultPhases = false;
    if (response.Status === 1) {
      this.selectedDefaultPhaseAgent.OrderPhases = response.Phases || [];
      this.parent.openSnackBar(response.Message || 'Default phases saved', 'OK', 'light-info-snackbar');
      this.closeDefaultPhasesPopup();
    } else {
      this.parent.openSnackBar(response.Message || 'Error saving default phases', 'OK', 'alert-info-snackbar');
    }
  });
}

}

